import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  VStack,
  Heading,
  Text,
  Button,
  Image,
  useColorModeValue,
  Container,
} from '@chakra-ui/react';
import { FiHome, FiArrowLeft } from 'react-icons/fi';

const NotFound = () => {
  const navigate = useNavigate();
  const bgColor = useColorModeValue('gray.50', 'gray.800');
  const textColor = useColorModeValue('gray.600', 'gray.400');

  return (
    <Box minH="100vh" bg={bgColor} py={20}>
      <Container maxW="container.xl">
        <VStack spacing={8} align="center" textAlign="center">
          <Image
            src="/404.svg"
            alt="404 illustration"
            maxW="400px"
            fallbackSrc="https://via.placeholder.com/400x300?text=404"
          />
          
          <VStack spacing={4}>
            <Heading
              size="2xl"
              bgGradient="linear(to-r, purple.500, blue.400)"
              bgClip="text"
            >
              404 - Page Not Found
            </Heading>
            <Text fontSize="xl" color={textColor} maxW="600px">
              Oops! The page you're looking for doesn't exist or has been moved.
              Let's get you back on track.
            </Text>
          </VStack>

          <VStack spacing={4} direction={{ base: 'column', md: 'row' }}>
            <Button
              leftIcon={<FiHome />}
              colorScheme="purple"
              size="lg"
              onClick={() => navigate('/admin/dashboard')}
            >
              Go to Dashboard
            </Button>
            <Button
              leftIcon={<FiArrowLeft />}
              variant="outline"
              size="lg"
              onClick={() => navigate(-1)}
            >
              Go Back
            </Button>
          </VStack>
        </VStack>
      </Container>
    </Box>
  );
};

export default NotFound; 